import { render, staticRenderFns } from "./grouplist.vue?vue&type=template&id=b901a224"
import script from "./grouplist.vue?vue&type=script&lang=js"
export * from "./grouplist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports